import React from 'react';
import { Draggable, DraggableProps } from 'react-beautiful-dnd';

export const ConditionalDraggable = ({
  isDraggable,
  children,
  ...otherProps
}: {
  isDraggable: boolean;
  children: DraggableProps['children'];
} & DraggableProps) => {
  return isDraggable ? (
    <Draggable {...otherProps}>{children}</Draggable>
  ) : (
    <>{(children as () => React.ReactElement<HTMLElement>)()}</>
  );
};
